import script from "./procureInvoiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./procureInvoiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./procureInvoiceDetail.vue?vue&type=style&index=0&id=61d42c9b&lang=less"

const __exports__ = script;

export default __exports__